import * as React from 'react';
import { Link } from 'react-router-dom';
import { getTranslator } from '../Translator';
import { DocumentTitle } from './DocumentTitle';
import { useAppSelector } from '../hooks';

export const NotFound = () => {
    const language = useAppSelector(state => state.language);
    const t = getTranslator(language);
    return <div>
        <DocumentTitle title={t['Page could not be found.']} />
        <p>{t['Page could not be found.']}</p>
        <p>
            <Link to="/">{t['Go to the main page']}</Link>
        </p>
    </div>;
}
